import React from "react";
import {Link} from "react-router-dom";
import "./nav.css"

class Header extends React.Component {
    render() {
        return (
            <div className="ui menu">
                <div className="ui container">
                    <div className="menu left">
                        <Link to="/"><p className="item">STAGED</p></Link>
                        <Link to="/artists"><p className="item">Artists</p></Link>
                        <a className="item" href="/">Calendar</a>
                        <a className="item" href="/">About Us</a>
                        <a className="item" href="/">Blog</a>
                    </div>
                    <div className="login menu right">
                        <a className="item" href="/">Login</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Header;